import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "risa-oasis-ui_v2";
import { updateEvBvStatus } from "../../../api/firebase/firestoreService";
import { BadgeWithIconProps } from "../../../data-model/badgeWithIconProps";
import ArrowRight from "../../../svg/arrowRight";
import BadgeDropdown from "../../badgeDropdown/badgeDropdown";
import BadgeWithIcon from "../../badgeWithIcon/badgeWithIcon";
import { ToastMessages } from "../../toasts/toastMessages";
interface ApproveEvbvProps {
  badgeList?: BadgeWithIconProps[];
  selectedBadge?: BadgeWithIconProps;
  onClose: () => void;
  orderId: string;
  shouldNavigateToSubmission?: boolean;
}
const ApproveEvbv = (props: ApproveEvbvProps) => {
  const [selectedBadge, setSelectedBadge] = React.useState<string>(
    props.selectedBadge?.id ?? "",
  );
  const [, setComments] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const navigate = useNavigate();

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await updateEvBvStatus(props.orderId, selectedBadge);
      toast.success(ToastMessages.EVBV_STATUS_UPDATED_SUCCESS);
      navigate(`/worklists/singleOrder/${props.orderId}`);
    } catch (error) {
      toast.error(ToastMessages.EVBV_STATUS_UPDATED_FAILURE);
    } finally {
      setIsLoading(false);
      props.onClose();
    }
  };
  return (
    <Modal
      dialogId={"approve-evbv-modal"}
      onSave={handleSave}
      title={"Approve and Move Queue"}
      saveButtonText={isLoading ? "Saving..." : "Approve"}
      cancelText={"Cancel"}
      onClose={props.onClose}
      onCancel={props.onClose}
      disableSave={isLoading}
    >
      <div className="auth-inaccuracy-modal sections flex flex-col gap-4">
        <div className="auth-inaacuracy-modal status-section">
          <div className="status-change header mb-2 text-small font-semibold text-primaryGray-2">
            Change status from :
          </div>
          <div className="status-change options flex items-center gap-2">
            <div className="current-status">
              <BadgeWithIcon
                text={props.selectedBadge?.text ?? ""}
                id={props.selectedBadge?.id ?? ""}
                bgColor={props.selectedBadge?.bgColor ?? ""}
                textColor={props.selectedBadge?.textColor ?? ""}
              />
            </div>
            <div className="status-change-icon">
              <ArrowRight width={16} height={16} />
            </div>
            <div className="status-to">
              <BadgeDropdown
                badgeList={props.badgeList ?? []}
                selectedBadge={props.selectedBadge ?? null}
                onClick={(badgeId) => {
                  setSelectedBadge(badgeId);
                }}
              />
            </div>
          </div>
        </div>

        <div className="auth-inaccuracy-modal comments-section">
          <div className="comments-section header mb-2 text-tiny font-normal text-primaryGray-2">
            Comments
          </div>
          <div className="comments-section comments-textarea">
            <textarea
              className="h-20 w-full rounded border border-gray-300 p-2 text-tiny font-normal"
              placeholder="Enter your comments here"
              onChange={(e) => {
                setComments(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ApproveEvbv;
